import axios, { AxiosResponse } from "axios";
import { StudentDailyReportInsertDTO } from "../../models/dtos/work-reports/StudentDailyReportInsertDTO";
import { StudentDailyReportReportingDTO } from "../../models/dtos/work-reports/StudentDailyReportReportingDTO";
import { StudentDailyReportReportingItemDTO } from "../../models/dtos/work-reports/StudentDailyReportReportingItemDTO";
import { StudentReportSaveOptionsDTO } from "../../models/dtos/work-reports/StudentReportSaveOptionsDTO";
import { DateRangeQueryString } from "../../models/query-strings/base/DateRangeQueryString";
import BaseService from "../base/BaseService";

export default class StudentDailyReports extends BaseService {
  sendToTelegram(): Promise<any> {
    return axios
      .post(`/StudentDailyReports/ToTelegram`)
      .then(function (response) {
        return response;
      });
  }

  sendToSMS(): Promise<any> {
    return axios.post(`/StudentDailyReports/ToSMS`).then(function (response) {
      return response;
    });
  }

  getDailyReportText(): Promise<any> {
    return axios
      .get(`/StudentDailyReports/GetDailyReportText`)
      .then(function (response) {
        return response.data;
      });
  }

  getReportByRange(
    query: DateRangeQueryString,
  ): Promise<StudentDailyReportReportingItemDTO[]> {
    return axios.get(`/StudentDailyReports`, { params: query }).then(function (
      response: AxiosResponse<StudentDailyReportReportingItemDTO[], any>,
    ) {
      return response.data;
    });
  }

  insert(dto: StudentDailyReportInsertDTO): Promise<any> {
    return axios.post(`/StudentDailyReports`, dto).then(function (
      response: AxiosResponse<any, any>,
    ) {
      return response;
    });
  }

  getInQueury(): Promise<any> {
    return axios.get(`/StudentDailyReports/InQueury`).then(function (
      response: AxiosResponse<any, any>,
    ) {
      return response.data;
    });
  }

  getStudentReportSaveOptions(): Promise<StudentReportSaveOptionsDTO> {
    return axios.get(`/StudentDailyReports/SaveReportStatus`).then(function (
      response: AxiosResponse<StudentReportSaveOptionsDTO, any>,
    ) {
      return response.data;
    });
  }
}
